import request from "@/API/request";

//获取主页数据
export function getHomeData(pageKey) {
    return request({
        url: `resource/api/ad/page/${pageKey}`,
        method: "get",
    });
}
// 获取消息通知
export function getUserMessage(data) {
    return request({
        url: `auth/api/message/list`,
        method: "get",
        params:data
    });
}
// 标记消息读取状态

export function updateUserMessage(messageId) {
    return request({
        url: `auth/api/message/read/${messageId}`,
        method: "put",
    });
}
